angular.module('ihestiaMenuHelp', ['spaceChat.client']);